export default __webpack_public_path__ + "static/media/Logo.60ffb8af.svg";